import axios from "axios";

export default {
    state: {
        lenders: null
    },
    
    getters: {
        allLenders(state) {
            return state.lenders == null ? [] : state.lenders.filter(item => item.isIntermediary === false);    
        },
        
        favouriteLenders({lenders}) {
            return lenders == null ? [] : lenders.filter(l => l.top10LenderRanking != null);
        },
        
        getLender: (state) => (lenderID) => {
            return state.lenders.find(l => l.lenderID === lenderID)
        }
    },
    
    actions: {
        loadLenders(context) {
            if (context.lenders != null) return;

            axios
                .get(process.env.VUE_APP_PRODUCTS_API_URL + "/products/lenders")
                .then(response => {
                    context.commit("setLenders", response.data);
                    console.log("API returned " + response.data.length + " lenders to store");
                })
                .catch(error => console.log(error));
        }
   },
    
    mutations: {
        setLenders(state, payload) {
            state.lenders = payload;
        }
    }
}